import { render, staticRenderFns } from "./SideBarNewInvoice.vue?vue&type=template&id=6910df69&"
import script from "./SideBarNewInvoice.vue?vue&type=script&lang=js&"
export * from "./SideBarNewInvoice.vue?vue&type=script&lang=js&"
import style0 from "./SideBarNewInvoice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports